import { VertiNodeLocale, type VertiNodeLocalizedString } from "../VertiNodeLocale.js";

export const vertiNodeLevelsPathMap = {
	[VertiNodeLocale.cs]: "vertinode-features",
	[VertiNodeLocale.en]: "vertinode-features",
} satisfies VertiNodeLocalizedString;
